/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/moje-produkty',
    name: 'Moje produkty',
    slug: 'baza-produktow',
    icon: 'BookIcon'
  },
  {
    url: '/baza-skladnikow',
    name: 'Baza składników',
    slug: 'baza-skladnikow',
    icon: 'FileIcon',
    admin: false
  },
  {
    url: '/moje-konto',
    name: 'Moje konto',
    slug: 'moje-konto',
    icon: 'UserIcon',
    admin: false
  },
  {
    url: '/subscriptions',
    name: 'Użytkownicy',
    slug: 'subscriptions',
    icon: 'UserIcon',
    admin: true
  },
  {
    url: '/faktury',
    name: 'Faktury',
    slug: 'faktury',
    icon: 'UserIcon',
    admin: true
  },
  {
    url: '/users',
    name: 'Users',
    slug: 'users',
    icon: 'UserIcon',
    admin: true
  },
  {
    url: '/global-allergens',
    name: 'Alergeny globalne',
    slug: 'alergeny-globalne',
    icon: 'BoldIcon',
    admin: true
  },
  {
    url: '/kontakt',
    name: 'Kontakt',
    slug: 'kontakt',
    icon: 'MailIcon',
    admin: false
  },
  {
    url: '/wyloguj',
    name: 'Wyloguj',
    slug: 'Wyloguj',
    icon: 'LogOutIcon',
    admin: false
  },
]
